import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const columns = [
    {
      title: "Product",
      items: [
        { label: "Features", href: "/#features" },
        { label: "How it works", href: "/#how" },
        { label: "Pricing", href: "/#pricing" },
        { label: "Calculator", href: "/#calculator" },
      ],
    },
    {
      title: "Company",
      items: [
        { label: "About", to: "/about" },
        { label: "Customers", href: "/#use-cases" },
        { label: "Contact", to: "/contact" },
      ],
    },
    {
      title: "Legal",
      items: [
        { label: "Privacy", to: "/privacy" },
        { label: "Terms", to: "/terms" },
        { label: "SMS consent", to: "/messaging-consent" },
        { label: "Security", to: "/security" },
      ],
    },
  ];

  return (
    <footer className="bg-[#183D36] text-[#FAF7F0]/90 pt-16 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-14">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-2xl bg-[#F4B183] text-[#183D36] flex items-center justify-center">
                <Sparkles size={16} strokeWidth={2} />
              </span>
              <span className="font-heading text-lg font-semibold">NextVisit</span>
            </div>
            <p className="text-sm text-[#FAF7F0]/70 max-w-sm leading-relaxed">
              The quiet follow-up system for appointment-based businesses. We turn every visit into the next one.
            </p>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <div className="overline text-[#F4B183] mb-4">{col.title}</div>
              <ul className="space-y-3 text-sm">
                {col.items.map((item) => (
                  <li key={item.label}>
                    {item.to ? (
                      <Link
                        to={item.to}
                        className="hover:text-[#F4B183] transition-colors"
                        data-testid={`footer-link-${col.title.toLowerCase()}-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                      >
                        {item.label}
                      </Link>
                    ) : (
                      <a
                        href={item.href}
                        className="hover:text-[#F4B183] transition-colors"
                        data-testid={`footer-link-${col.title.toLowerCase()}-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-8 border-t border-[#FAF7F0]/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#FAF7F0]/60 font-accent">© 2025 NextVisit · bookyournextvisit.com — Made with care for small teams.</p>
          <p className="text-xs text-[#FAF7F0]/60 font-accent">Turn every visit into the next one.</p>
        </div>
      </div>
    </footer>
  );
}
